<template>
  <div>
    <p class="title">{{ title }}</p>
    <div>
      <el-radio-group
        v-model="selectedMutable"
        size="small"
        @change="update()"
      >
        <el-radio-button
          v-for="(element, index) in elements"
          :key="index"
          :label="element.name"
          class="pill"
        />

        <el-radio-button
          v-if="hasOthers"
          :label="other.name"
          class="pill fix-radio-other-click"
          @click.prevent="openDataPicker"
        >
          <div
            @click="openDataPicker"
            style="padding: 8px 14px;"
          >
            <el-date-picker
              v-model="dataPickerValue"
              type="daterange"
              align="right"
              start-placeholder="Data inicial"
              end-placeholder="Data Final"
              default-value="2010-10-01"
              ref="dataPicker"
              clearable
              class="data-picker-hidden"
              @blur="updateOtherDate"
            />
            {{ other.name }}

          </div>
        </el-radio-button>

      </el-radio-group>

    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'FilterComponentPeriodo',
  props: {
    title: {
      type: String,
      default: ''
    },
    elements: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hasOthers: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selected (newValue) {
      this.selectedMutable = newValue && newValue.name
    }
  },
  data () {
    return {
      selectedMutable: {},
      other: {
        name: 'Outros...'
      },
      dataPickerValue: '',
      test: true
    }
  },
  created () {
    this.selectedMutable = this.selected && this.selected.name

    if (this.selectedMutable) {
      if (this.isOther(this.selectedMutable)) {
        this.other = this.selectedMutable
      } else {
        this.other = {
          name: 'Outros...'
        }
      }
    }
  },
  methods: {
    update () {
      let selectedWithTime = this.elements.find((el) => el.name === this.selectedMutable)

      if (selectedWithTime) {
        selectedWithTime.periodo_fim = moment().format('YYYY-MM-DD')
        let periodoInicio = moment().subtract(selectedWithTime.periodo, 'days')
        selectedWithTime.periodo_inicio = periodoInicio.format('YYYY-MM-DD')
        this.$emit('update:selected', selectedWithTime)
      }
    },
    isOther (elName) {
      return !this.elements.find((el) => el.name === elName)
    },
    openDataPicker () {
      this.$refs.dataPicker.showPicker()
    },
    updateOtherDate () {
      if (!this.dataPickerValue || this.dataPickerValue.length !== 2) {
        this.selectedMutable = this.selected && this.selected.name
      }
      const dateStart = moment(this.dataPickerValue[0])
      const dateEnd = moment(this.dataPickerValue[1])
      const name = `${dateStart.format('DD-MM-YYYY')} - ${dateEnd.format('DD-MM-YYYY')}`
      this.other = {
        name,
        periodo_inicio: dateStart.format('YYYY-MM-DD'),
        periodo_fim: dateEnd.format('YYYY-MM-DD')
      }
      this.selectedMutable = name
      this.$emit('update:selected', this.other)
    }
  }
}
</script>

<style>
.pill {
  margin-right: 10px;
}

.pill > span {
  border-radius: 20px !important;
}

.data-picker-hidden {
  display: flex !important;
  visibility: hidden !important;
  width: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

/*noinspection CssUnusedSymbol*/
.fix-radio-other-click > .el-radio-button__inner {
/* Alterando a classe para aumentar a area de click */
  padding: 0;
}
</style>
